// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMSubHeader-module__font-s-10___F5Icf {
  font-size: 10px !important;
}

.CGMSubHeader-module__font-s-12___NCxgx {
  font-size: 12px !important;
}

.CGMSubHeader-module__font-s-13___bXNY2 {
  font-size: 13px !important;
}

.CGMSubHeader-module__font-s-14___eGoAt {
  font-size: 14px !important;
}

.CGMSubHeader-module__font-s-15___gjH2B {
  font-size: 15px !important;
}

.CGMSubHeader-module__font-s-16___pX3Hv {
  font-size: 16px !important;
}

.CGMSubHeader-module__font-s-18___PYLjK {
  font-size: 18px !important;
}

.CGMSubHeader-module__font-s-20___Mr161 {
  font-size: 20px !important;
}

.CGMSubHeader-module__font-s-22___LTXgB {
  font-size: 22px !important;
}

.CGMSubHeader-module__font-s-28___zHg6D {
  font-size: 28px !important;
}

.CGMSubHeader-module__font-w-400___If3fI {
  font-weight: 400 !important;
}

.CGMSubHeader-module__font-w-500___xg9j1 {
  font-weight: 500 !important;
}

.CGMSubHeader-module__font-w-600___WYkEy {
  font-weight: 600 !important;
}

.CGMSubHeader-module__font-w-700___m5LGm {
  font-weight: 700 !important;
}

.CGMSubHeader-module__p-5___z8nrC {
  padding: 5px !important;
}

.CGMSubHeader-module__p-12___pSxrT {
  padding: 12px !important;
}

.CGMSubHeader-module__p-16___r3Fog {
  padding: 16px !important;
}

.CGMSubHeader-module__p-30___q9iM0 {
  padding: 30px !important;
}

.CGMSubHeader-module__p-b-0___Mx6m5 {
  padding-bottom: 0 !important;
}

.CGMSubHeader-module__p-b-5___Mrxvu {
  padding-bottom: 5px !important;
}

.CGMSubHeader-module__p-b-10___JWTAo {
  padding-bottom: 10px !important;
}

.CGMSubHeader-module__p-b-12___sHA6c {
  padding-bottom: 12px !important;
}

.CGMSubHeader-module__p-b-16___oHhtA {
  padding-bottom: 16px !important;
}

.CGMSubHeader-module__p-b-18___CNOkD {
  padding-bottom: 18px !important;
}

.CGMSubHeader-module__p-b-20___SD1zU {
  padding-bottom: 20px !important;
}

.CGMSubHeader-module__p-b-25___y8STd {
  padding-bottom: 25px !important;
}

.CGMSubHeader-module__p-b-30___vTJrO {
  padding-bottom: 30px !important;
}

.CGMSubHeader-module__p-b-50___AwEBj {
  padding-bottom: 50px !important;
}

.CGMSubHeader-module__p-t-0___OSsDY {
  padding-top: 0 !important;
}

.CGMSubHeader-module__p-t-12___FY91s {
  padding-top: 12px !important;
}

.CGMSubHeader-module__p-t-16___RLAYU {
  padding-top: 16px !important;
}

.CGMSubHeader-module__p-t-18___yVllH {
  padding-top: 18px !important;
}

.CGMSubHeader-module__p-t-20___lASj_ {
  padding-top: 20px !important;
}

.CGMSubHeader-module__p-t-30___MooFv {
  padding-top: 30px !important;
}

.CGMSubHeader-module__p-t-40___RcHfY {
  padding-top: 40px !important;
}

.CGMSubHeader-module__p-t-50___qZBCm {
  padding-top: 50px !important;
}

.CGMSubHeader-module__p-l-20___HKr1A {
  padding-left: 20px !important;
}

.CGMSubHeader-module__p-l-30___a4tJu {
  padding-left: 30px !important;
}

.CGMSubHeader-module__p-l-40___Y7xyc {
  padding-left: 40px !important;
}

.CGMSubHeader-module__p-r-16___FVIJH {
  padding-right: 16px !important;
}

.CGMSubHeader-module__p-r-20___HuA9u {
  padding-right: 20px !important;
}

.CGMSubHeader-module__p-r-30___Gonor {
  padding-right: 30px !important;
}

.CGMSubHeader-module__p-r-50____f0PC {
  padding-right: 50px !important;
}

.CGMSubHeader-module__p-r-60___WRLct {
  padding-right: 60px !important;
}

.CGMSubHeader-module__m-b-1___d7d2V {
  margin-bottom: 1px !important;
}

.CGMSubHeader-module__m-b-2___NnXPa {
  margin-bottom: 2px !important;
}

.CGMSubHeader-module__m-b-6___zRHe6 {
  margin-bottom: 6px !important;
}

.CGMSubHeader-module__m-b-8___w8yZX {
  margin-bottom: 8px !important;
}

.CGMSubHeader-module__m-b-10___hCwyL {
  margin-bottom: 10px !important;
}

.CGMSubHeader-module__m-b-14___WuvJz {
  margin-bottom: 14px !important;
}

.CGMSubHeader-module__m-b-16___LU74p {
  margin-bottom: 16px !important;
}

.CGMSubHeader-module__m-b-20___zN42r {
  margin-bottom: 20px !important;
}

.CGMSubHeader-module__m-b-22____WuCW {
  margin-bottom: 22px !important;
}

.CGMSubHeader-module__m-b-24___qKRxe {
  margin-bottom: 24px !important;
}

.CGMSubHeader-module__m-b-30___Qjm5b {
  margin-bottom: 30px !important;
}

.CGMSubHeader-module__m-b-32___eI2oT {
  margin-bottom: 32px !important;
}

.CGMSubHeader-module__m-b-40___tnKUb {
  margin-bottom: 40px !important;
}

.CGMSubHeader-module__m-t-2___oth1l {
  margin-top: 2px !important;
}

.CGMSubHeader-module__m-t-3___PxOmJ {
  margin-top: 3px !important;
}

.CGMSubHeader-module__m-t-4___sAWP0 {
  margin-top: 4px !important;
}

.CGMSubHeader-module__m-t-5___tYRMi {
  margin-top: 5px !important;
}

.CGMSubHeader-module__m-t-8___JkSK_ {
  margin-top: 8px !important;
}

.CGMSubHeader-module__m-t-10___R81c6 {
  margin-top: 10px !important;
}

.CGMSubHeader-module__m-t-15___vRyw7 {
  margin-top: 15px !important;
}

.CGMSubHeader-module__m-t-16___NTTbC {
  margin-top: 16px !important;
}

.CGMSubHeader-module__m-t-20___r1xen {
  margin-top: 20px !important;
}

.CGMSubHeader-module__m-t-22___wesIH {
  margin-top: 22px !important;
}

.CGMSubHeader-module__m-t-30___apJvJ {
  margin-top: 30px !important;
}

.CGMSubHeader-module__m-t-32___deb1U {
  margin-top: 32px !important;
}

.CGMSubHeader-module__m-l-auto___tlexi {
  margin-left: auto !important;
}

.CGMSubHeader-module__m-l-4___Lv9yM {
  margin-left: 4px !important;
}

.CGMSubHeader-module__m-l-5___SE9Tk {
  margin-left: 5px !important;
}

.CGMSubHeader-module__m-l-6___oB7NT {
  margin-left: 6px !important;
}

.CGMSubHeader-module__m-l-8___eMAxR {
  margin-left: 8px !important;
}

.CGMSubHeader-module__m-l-10___vSyz3 {
  margin-left: 10px !important;
}

.CGMSubHeader-module__m-l-16___DWN2p {
  margin-left: 16px !important;
}

.CGMSubHeader-module__m-l-20___gJjPC {
  margin-left: 20px !important;
}

.CGMSubHeader-module__m-l-24___gFnpT {
  margin-left: 24px !important;
}

.CGMSubHeader-module__m-l-30___NctPl {
  margin-left: 30px !important;
}

.CGMSubHeader-module__m-l-35___z3mpU {
  margin-left: 35px !important;
}

.CGMSubHeader-module__m-l-40___I6ta3 {
  margin-left: 40px !important;
}

.CGMSubHeader-module__m-r-8___W7khC {
  margin-right: 8px !important;
}

.CGMSubHeader-module__m-r-10___FINCQ {
  margin-right: 10px !important;
}

.CGMSubHeader-module__m-r-16___durxT {
  margin-right: 16px !important;
}

.CGMSubHeader-module__m-r-20___QqET7 {
  margin-right: 20px !important;
}

.CGMSubHeader-module__m-r-24___WhuOD {
  margin-right: 24px !important;
}

.CGMSubHeader-module__m-r-30___lqziG {
  margin-right: 30px !important;
}

.CGMSubHeader-module__m-r-40___nhCNq {
  margin-right: 40px !important;
}

.CGMSubHeader-module__border-r-3___FWQo_ {
  border-radius: 3px !important;
}

.CGMSubHeader-module__border-r-4___ReBTA {
  border-radius: 4px !important;
}

.CGMSubHeader-module__border-r-6___fi6N4 {
  border-radius: 6px !important;
}

.CGMSubHeader-module__border-r-10___aE9ID {
  border-radius: 10px !important;
}

.CGMSubHeader-module__border-r-12___j8RbK {
  border-radius: 12px !important;
}

.CGMSubHeader-module__border-r-16___UbqAs {
  border-radius: 16px !important;
}

.CGMSubHeader-module__border-r-50___iNUmj {
  border-radius: 50% !important;
}

.CGMSubHeader-module__primary-border___mimFk {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMSubHeader-module__primary-border-b___BNf2B {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMSubHeader-module__primary-border-t___D65ZO {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMSubHeader-module__primary-border-l___LShXf {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMSubHeader-module__primary-border-r___CIo9W {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMSubHeader-module__secondary-border___YAC77 {
  border: 1px solid #637768;
}

.CGMSubHeader-module__secondary-border-b___H3kLf {
  border-bottom: 1px solid #637768;
}

.CGMSubHeader-module__secondary-border-t___Kkd76 {
  border-top: 1px solid #637768;
}

.CGMSubHeader-module__secondary-border-l___lx9gI {
  border-left: 1px solid #637768;
}

.CGMSubHeader-module__secondary-border-r___EJkIi {
  border-right: 1px solid #637768;
}

.CGMSubHeader-module__gap-0___kUlUO {
  gap: 0 !important;
}

.CGMSubHeader-module__gap-2___Lx3Hu {
  gap: 2px !important;
}

.CGMSubHeader-module__gap-4___G6yI1 {
  gap: 4px !important;
}

.CGMSubHeader-module__gap-5___tm12w {
  gap: 5px !important;
}

.CGMSubHeader-module__gap-6___eQpRE {
  gap: 6px !important;
}

.CGMSubHeader-module__gap-8___Iuxl5 {
  gap: 8px !important;
}

.CGMSubHeader-module__gap-10___uSFSW {
  gap: 10px !important;
}

.CGMSubHeader-module__gap-12___NCciA {
  gap: 12px !important;
}

.CGMSubHeader-module__gap-14___xaFaw {
  gap: 14px !important;
}

.CGMSubHeader-module__gap-16___dlcXE {
  gap: 16px !important;
}

.CGMSubHeader-module__gap-18___IBobv {
  gap: 18px !important;
}

.CGMSubHeader-module__gap-20___y8itb {
  gap: 20px !important;
}

.CGMSubHeader-module__gap-24___BmqRI {
  gap: 24px !important;
}

.CGMSubHeader-module__gap-26___yUivh {
  gap: 26px !important;
}

.CGMSubHeader-module__gap-30___Mvu7Q {
  gap: 30px !important;
}

.CGMSubHeader-module__gap-32___fbblD {
  gap: 32px !important;
}

.CGMSubHeader-module__gap-40___zgY0R {
  gap: 40px !important;
}

.CGMSubHeader-module__gap-50___ELP25 {
  gap: 50px !important;
}

.CGMSubHeader-module__flex-1___wDTee {
  flex: 1;
}

.CGMSubHeader-module__flex-none___b86N0 {
  flex: none !important;
}

.CGMSubHeader-module__flex-column___bSWVm {
  display: flex;
  flex-direction: column !important;
}

.CGMSubHeader-module__flex-row___CN9Kw {
  display: flex;
  flex-direction: row !important;
}

.CGMSubHeader-module__vertically-centered___CkEq1 {
  display: flex;
  align-items: center !important;
}

.CGMSubHeader-module__horizontally-centered___qgkB9 {
  display: flex;
  justify-content: center !important;
}

.CGMSubHeader-module__horizontally-end___Z73Zo {
  display: flex;
  justify-content: end !important;
}

.CGMSubHeader-module__vertically-start___U8GFY {
  display: flex;
  align-items: start !important;
}

.CGMSubHeader-module__space-between___b96wM {
  display: flex;
  justify-content: space-between !important;
}

.CGMSubHeader-module__flex-wrap___ysrfQ {
  flex-wrap: wrap !important;
}

.CGMSubHeader-module__height-100___I7bo2 {
  height: 100%;
}

.CGMSubHeader-module__width-50___iLH9b {
  width: 50% !important;
}

.CGMSubHeader-module__width-100___hBl9O {
  width: 100%;
}

.CGMSubHeader-module__cursor-pointer___DA56L {
  cursor: pointer;
}

.CGMSubHeader-module__cursor-not-allowed___YBw3n {
  cursor: not-allowed !important;
}

.CGMSubHeader-module__absolute-centered___nq7fM {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMSubHeader-module__absolute___s37Nx {
  position: absolute;
}

.CGMSubHeader-module__relative___mZcyf {
  position: relative;
}

.CGMSubHeader-module__fixed___ZjwKy {
  position: fixed;
}

.CGMSubHeader-module__visible___aXlYg {
  opacity: 1;
}

.CGMSubHeader-module__invisible___SM5sx {
  opacity: 0;
}

.CGMSubHeader-module__col-90___A4z8g {
  width: 90% !important;
}

.CGMSubHeader-module__col-auto___QvSzQ {
  width: auto !important;
}

.CGMSubHeader-module__medical-tabs___NyqbC {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMSubHeader-module__medical-table-new___dymmg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMSubHeader-module__medical-table-new___dymmg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMSubHeader-module__medical-table-new___dymmg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMSubHeader-module__medical-table-new___dymmg::-webkit-scrollbar-track {
  display: none;
}
.CGMSubHeader-module__medical-table-new___dymmg.CGMSubHeader-module__no-pagination___mOTav {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMSubHeader-module__medical-table-new___dymmg.CGMSubHeader-module__no-pagination___mOTav:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMSubHeader-module__medical-table-new___dymmg.CGMSubHeader-module__no-pagination___mOTav::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMSubHeader-module__medical-table-new___dymmg.CGMSubHeader-module__no-pagination___mOTav::-webkit-scrollbar-track {
  display: none;
}

.CGMSubHeader-module__medical-table-empty___MbhVf {
  padding: 14px 40px !important;
}

.CGMSubHeader-module__icon-btn___Zybx_ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMSubHeader-module__search-icon___LR1LD {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMSubHeader-module__disable-select___KSxrc {
  user-select: none;
}

.CGMSubHeader-module__break-word___Gq_QO {
  word-break: break-word;
}

.CGMSubHeader-module__popup-clear-btn___dC024 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMSubHeader-module__scroll-m-b-20___iYvul {
  scroll-margin-bottom: 20px;
}

.CGMSubHeader-module__title___aC59P {
  color: #375844;
}

.CGMSubHeader-module__wrapper___dGw2O {
  gap: 9%;
  display: flex;
  width: calc(100% - 50px);
}
.CGMSubHeader-module__wrapper___dGw2O .CGMSubHeader-module__description___J7Ah3 {
  color: #375844;
}
.CGMSubHeader-module__wrapper___dGw2O .CGMSubHeader-module__statuses___QIYIk {
  gap: 55px;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/headers/CGMSubHeader/CGMSubHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,OAAA;EACA,aAAA;EACA,wBAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA3pBE;EACE,SAAA;EACA,aAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.title {\n  color: get-color(greenNew, dark);\n}\n\n.wrapper {\n  gap: 9%;\n  display: flex;\n  width: calc(100% - 50px);\n\n  .description {\n    color: get-color(greenNew, dark);\n  }\n\n  .statuses {\n    gap: 55px;\n    display: flex;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMSubHeader-module__font-s-10___F5Icf`,
	"fontS12": `CGMSubHeader-module__font-s-12___NCxgx`,
	"fontS13": `CGMSubHeader-module__font-s-13___bXNY2`,
	"fontS14": `CGMSubHeader-module__font-s-14___eGoAt`,
	"fontS15": `CGMSubHeader-module__font-s-15___gjH2B`,
	"fontS16": `CGMSubHeader-module__font-s-16___pX3Hv`,
	"fontS18": `CGMSubHeader-module__font-s-18___PYLjK`,
	"fontS20": `CGMSubHeader-module__font-s-20___Mr161`,
	"fontS22": `CGMSubHeader-module__font-s-22___LTXgB`,
	"fontS28": `CGMSubHeader-module__font-s-28___zHg6D`,
	"fontW400": `CGMSubHeader-module__font-w-400___If3fI`,
	"fontW500": `CGMSubHeader-module__font-w-500___xg9j1`,
	"fontW600": `CGMSubHeader-module__font-w-600___WYkEy`,
	"fontW700": `CGMSubHeader-module__font-w-700___m5LGm`,
	"p5": `CGMSubHeader-module__p-5___z8nrC`,
	"p12": `CGMSubHeader-module__p-12___pSxrT`,
	"p16": `CGMSubHeader-module__p-16___r3Fog`,
	"p30": `CGMSubHeader-module__p-30___q9iM0`,
	"pB0": `CGMSubHeader-module__p-b-0___Mx6m5`,
	"pB5": `CGMSubHeader-module__p-b-5___Mrxvu`,
	"pB10": `CGMSubHeader-module__p-b-10___JWTAo`,
	"pB12": `CGMSubHeader-module__p-b-12___sHA6c`,
	"pB16": `CGMSubHeader-module__p-b-16___oHhtA`,
	"pB18": `CGMSubHeader-module__p-b-18___CNOkD`,
	"pB20": `CGMSubHeader-module__p-b-20___SD1zU`,
	"pB25": `CGMSubHeader-module__p-b-25___y8STd`,
	"pB30": `CGMSubHeader-module__p-b-30___vTJrO`,
	"pB50": `CGMSubHeader-module__p-b-50___AwEBj`,
	"pT0": `CGMSubHeader-module__p-t-0___OSsDY`,
	"pT12": `CGMSubHeader-module__p-t-12___FY91s`,
	"pT16": `CGMSubHeader-module__p-t-16___RLAYU`,
	"pT18": `CGMSubHeader-module__p-t-18___yVllH`,
	"pT20": `CGMSubHeader-module__p-t-20___lASj_`,
	"pT30": `CGMSubHeader-module__p-t-30___MooFv`,
	"pT40": `CGMSubHeader-module__p-t-40___RcHfY`,
	"pT50": `CGMSubHeader-module__p-t-50___qZBCm`,
	"pL20": `CGMSubHeader-module__p-l-20___HKr1A`,
	"pL30": `CGMSubHeader-module__p-l-30___a4tJu`,
	"pL40": `CGMSubHeader-module__p-l-40___Y7xyc`,
	"pR16": `CGMSubHeader-module__p-r-16___FVIJH`,
	"pR20": `CGMSubHeader-module__p-r-20___HuA9u`,
	"pR30": `CGMSubHeader-module__p-r-30___Gonor`,
	"pR50": `CGMSubHeader-module__p-r-50____f0PC`,
	"pR60": `CGMSubHeader-module__p-r-60___WRLct`,
	"mB1": `CGMSubHeader-module__m-b-1___d7d2V`,
	"mB2": `CGMSubHeader-module__m-b-2___NnXPa`,
	"mB6": `CGMSubHeader-module__m-b-6___zRHe6`,
	"mB8": `CGMSubHeader-module__m-b-8___w8yZX`,
	"mB10": `CGMSubHeader-module__m-b-10___hCwyL`,
	"mB14": `CGMSubHeader-module__m-b-14___WuvJz`,
	"mB16": `CGMSubHeader-module__m-b-16___LU74p`,
	"mB20": `CGMSubHeader-module__m-b-20___zN42r`,
	"mB22": `CGMSubHeader-module__m-b-22____WuCW`,
	"mB24": `CGMSubHeader-module__m-b-24___qKRxe`,
	"mB30": `CGMSubHeader-module__m-b-30___Qjm5b`,
	"mB32": `CGMSubHeader-module__m-b-32___eI2oT`,
	"mB40": `CGMSubHeader-module__m-b-40___tnKUb`,
	"mT2": `CGMSubHeader-module__m-t-2___oth1l`,
	"mT3": `CGMSubHeader-module__m-t-3___PxOmJ`,
	"mT4": `CGMSubHeader-module__m-t-4___sAWP0`,
	"mT5": `CGMSubHeader-module__m-t-5___tYRMi`,
	"mT8": `CGMSubHeader-module__m-t-8___JkSK_`,
	"mT10": `CGMSubHeader-module__m-t-10___R81c6`,
	"mT15": `CGMSubHeader-module__m-t-15___vRyw7`,
	"mT16": `CGMSubHeader-module__m-t-16___NTTbC`,
	"mT20": `CGMSubHeader-module__m-t-20___r1xen`,
	"mT22": `CGMSubHeader-module__m-t-22___wesIH`,
	"mT30": `CGMSubHeader-module__m-t-30___apJvJ`,
	"mT32": `CGMSubHeader-module__m-t-32___deb1U`,
	"mLAuto": `CGMSubHeader-module__m-l-auto___tlexi`,
	"mL4": `CGMSubHeader-module__m-l-4___Lv9yM`,
	"mL5": `CGMSubHeader-module__m-l-5___SE9Tk`,
	"mL6": `CGMSubHeader-module__m-l-6___oB7NT`,
	"mL8": `CGMSubHeader-module__m-l-8___eMAxR`,
	"mL10": `CGMSubHeader-module__m-l-10___vSyz3`,
	"mL16": `CGMSubHeader-module__m-l-16___DWN2p`,
	"mL20": `CGMSubHeader-module__m-l-20___gJjPC`,
	"mL24": `CGMSubHeader-module__m-l-24___gFnpT`,
	"mL30": `CGMSubHeader-module__m-l-30___NctPl`,
	"mL35": `CGMSubHeader-module__m-l-35___z3mpU`,
	"mL40": `CGMSubHeader-module__m-l-40___I6ta3`,
	"mR8": `CGMSubHeader-module__m-r-8___W7khC`,
	"mR10": `CGMSubHeader-module__m-r-10___FINCQ`,
	"mR16": `CGMSubHeader-module__m-r-16___durxT`,
	"mR20": `CGMSubHeader-module__m-r-20___QqET7`,
	"mR24": `CGMSubHeader-module__m-r-24___WhuOD`,
	"mR30": `CGMSubHeader-module__m-r-30___lqziG`,
	"mR40": `CGMSubHeader-module__m-r-40___nhCNq`,
	"borderR3": `CGMSubHeader-module__border-r-3___FWQo_`,
	"borderR4": `CGMSubHeader-module__border-r-4___ReBTA`,
	"borderR6": `CGMSubHeader-module__border-r-6___fi6N4`,
	"borderR10": `CGMSubHeader-module__border-r-10___aE9ID`,
	"borderR12": `CGMSubHeader-module__border-r-12___j8RbK`,
	"borderR16": `CGMSubHeader-module__border-r-16___UbqAs`,
	"borderR50": `CGMSubHeader-module__border-r-50___iNUmj`,
	"primaryBorder": `CGMSubHeader-module__primary-border___mimFk`,
	"primaryBorderB": `CGMSubHeader-module__primary-border-b___BNf2B`,
	"primaryBorderT": `CGMSubHeader-module__primary-border-t___D65ZO`,
	"primaryBorderL": `CGMSubHeader-module__primary-border-l___LShXf`,
	"primaryBorderR": `CGMSubHeader-module__primary-border-r___CIo9W`,
	"secondaryBorder": `CGMSubHeader-module__secondary-border___YAC77`,
	"secondaryBorderB": `CGMSubHeader-module__secondary-border-b___H3kLf`,
	"secondaryBorderT": `CGMSubHeader-module__secondary-border-t___Kkd76`,
	"secondaryBorderL": `CGMSubHeader-module__secondary-border-l___lx9gI`,
	"secondaryBorderR": `CGMSubHeader-module__secondary-border-r___EJkIi`,
	"gap0": `CGMSubHeader-module__gap-0___kUlUO`,
	"gap2": `CGMSubHeader-module__gap-2___Lx3Hu`,
	"gap4": `CGMSubHeader-module__gap-4___G6yI1`,
	"gap5": `CGMSubHeader-module__gap-5___tm12w`,
	"gap6": `CGMSubHeader-module__gap-6___eQpRE`,
	"gap8": `CGMSubHeader-module__gap-8___Iuxl5`,
	"gap10": `CGMSubHeader-module__gap-10___uSFSW`,
	"gap12": `CGMSubHeader-module__gap-12___NCciA`,
	"gap14": `CGMSubHeader-module__gap-14___xaFaw`,
	"gap16": `CGMSubHeader-module__gap-16___dlcXE`,
	"gap18": `CGMSubHeader-module__gap-18___IBobv`,
	"gap20": `CGMSubHeader-module__gap-20___y8itb`,
	"gap24": `CGMSubHeader-module__gap-24___BmqRI`,
	"gap26": `CGMSubHeader-module__gap-26___yUivh`,
	"gap30": `CGMSubHeader-module__gap-30___Mvu7Q`,
	"gap32": `CGMSubHeader-module__gap-32___fbblD`,
	"gap40": `CGMSubHeader-module__gap-40___zgY0R`,
	"gap50": `CGMSubHeader-module__gap-50___ELP25`,
	"flex1": `CGMSubHeader-module__flex-1___wDTee`,
	"flexNone": `CGMSubHeader-module__flex-none___b86N0`,
	"flexColumn": `CGMSubHeader-module__flex-column___bSWVm`,
	"flexRow": `CGMSubHeader-module__flex-row___CN9Kw`,
	"verticallyCentered": `CGMSubHeader-module__vertically-centered___CkEq1`,
	"horizontallyCentered": `CGMSubHeader-module__horizontally-centered___qgkB9`,
	"horizontallyEnd": `CGMSubHeader-module__horizontally-end___Z73Zo`,
	"verticallyStart": `CGMSubHeader-module__vertically-start___U8GFY`,
	"spaceBetween": `CGMSubHeader-module__space-between___b96wM`,
	"flexWrap": `CGMSubHeader-module__flex-wrap___ysrfQ`,
	"height100": `CGMSubHeader-module__height-100___I7bo2`,
	"width50": `CGMSubHeader-module__width-50___iLH9b`,
	"width100": `CGMSubHeader-module__width-100___hBl9O`,
	"cursorPointer": `CGMSubHeader-module__cursor-pointer___DA56L`,
	"cursorNotAllowed": `CGMSubHeader-module__cursor-not-allowed___YBw3n`,
	"absoluteCentered": `CGMSubHeader-module__absolute-centered___nq7fM`,
	"absolute": `CGMSubHeader-module__absolute___s37Nx`,
	"relative": `CGMSubHeader-module__relative___mZcyf`,
	"fixed": `CGMSubHeader-module__fixed___ZjwKy`,
	"visible": `CGMSubHeader-module__visible___aXlYg`,
	"invisible": `CGMSubHeader-module__invisible___SM5sx`,
	"col90": `CGMSubHeader-module__col-90___A4z8g`,
	"colAuto": `CGMSubHeader-module__col-auto___QvSzQ`,
	"medicalTabs": `CGMSubHeader-module__medical-tabs___NyqbC`,
	"medicalTableNew": `CGMSubHeader-module__medical-table-new___dymmg`,
	"noPagination": `CGMSubHeader-module__no-pagination___mOTav`,
	"medicalTableEmpty": `CGMSubHeader-module__medical-table-empty___MbhVf`,
	"iconBtn": `CGMSubHeader-module__icon-btn___Zybx_`,
	"searchIcon": `CGMSubHeader-module__search-icon___LR1LD`,
	"disableSelect": `CGMSubHeader-module__disable-select___KSxrc`,
	"breakWord": `CGMSubHeader-module__break-word___Gq_QO`,
	"popupClearBtn": `CGMSubHeader-module__popup-clear-btn___dC024`,
	"scrollMB20": `CGMSubHeader-module__scroll-m-b-20___iYvul`,
	"title": `CGMSubHeader-module__title___aC59P`,
	"wrapper": `CGMSubHeader-module__wrapper___dGw2O`,
	"description": `CGMSubHeader-module__description___J7Ah3`,
	"statuses": `CGMSubHeader-module__statuses___QIYIk`
};
module.exports = ___CSS_LOADER_EXPORT___;
